export default {
    GENERATE_SCREEN_ERROR_MESSAGE: "Не удалось сформировать снимок экрана"
};
